import { USER_ROLES } from './general';

export const campaignStates = {
	NEW: 1,
	RUNNING: 2,
	TERMINATED: 4,
};

export const campaignTypes = {
	X_SELL: 0, // Produkce
	UP_SELL: 3, // Dožití
};

export const allowedCampaignStatesForRole = {
	[USER_ROLES.PPZ]: [campaignStates.RUNNING],
	[USER_ROLES.SELLER]: [campaignStates.RUNNING],
	[USER_ROLES.GROUP_MANAGER]: [campaignStates.NEW, campaignStates.RUNNING],
	[USER_ROLES.AGENCY_MANAGER]: [campaignStates.NEW, campaignStates.RUNNING],
	[USER_ROLES.REGION_MANAGER]: [campaignStates.NEW, campaignStates.RUNNING],
	[USER_ROLES.DISTRICT_MANAGER]: [campaignStates.NEW, campaignStates.RUNNING],
	[USER_ROLES.GUARANTOR]: [campaignStates.NEW, campaignStates.RUNNING],
	[USER_ROLES.CENTRAL]: [campaignStates.NEW, campaignStates.RUNNING, campaignStates.TERMINATED],
};
